<template>
    <div class="logo">
        <router-link :to="moduleGroup==1?{name:'main-analysis'}:{name: 'WebIndex'}">
            <img v-if="navTheme === 'dark'" src="~@/assets/logo.png" alt="logo">
            <img v-else src="~@/assets/logo.png" alt="logo">
            <h1 v-if="showTitle">{{ title }}</h1>
        </router-link>
    </div>
</template>

<script>

    import { mixin } from '@/utils/mixin.js'

    export default {
        name: "Logo",
        mixins: [mixin],
        props: {
            title: {
                type: String,
                default: 'esmartxx',
                required: false
            },
            showTitle: {
                type: Boolean,
                default: true,
                required: false
            },
            // ----------------------------------------------------------------------- 开发Web增加的 start
            moduleGroup: {
                type: Number,
                required: false,
                default: 1,                                     // 功能模块组别：1=后台，2=web
            }
            // ----------------------------------------------------------------------- 开发Web增加的 end
        }
    }
</script>

<style lang="less" scoped>
    /*缩小首页布 局顶部的高度*/
    @height: 59px;
    .sider {
        box-shadow: none !important;
        .logo {
            height: @height !important;
            line-height: @height !important;
            box-shadow: none !important;
            transition: background 300ms;
            a {
                color: white;
                &:hover {
                    color: rgba(255, 255, 255, 0.8);
                }
            }
        }
        &.light .logo {
            background-color: @primary-color;
        }
    }


</style>
